"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToDomainInvoice = mapToDomainInvoice;
exports.mapToDomainInvoiceList = mapToDomainInvoiceList;
function mapToDomainInvoice(dto) {
    return {
        invoiceId: dto.invoiceId,
        clubId: dto.clubId,
        clubName: dto.clubName,
        invoiceType: dto.invoiceType,
        issuer: mapToDomainParty(dto.issuer),
        customer: mapToDomainParty(dto.customer),
        createDate: dto.createDate,
        orderId: dto.orderId,
        lineItems: dto.lineItems.map(mapToDomainLineItem),
        vatDetails: dto.vatDetails.map(mapToDomainVatDetails),
        totalTaxBase: dto.totalTaxBase,
        grossAmount: dto.grossAmount,
        currency: dto.currency,
        billingVerificationSystem: mapToDomainBillingVerificationSystem(dto.billingVerificationSystem),
    };
}
function mapToDomainParty(partyDto) {
    if (!partyDto)
        return null;
    return {
        legalName: partyDto.legalName ?? '',
        name: partyDto.name,
        address: {
            street: partyDto.address.street,
            postalCode: partyDto.address.postalCode,
            city: partyDto.address.city,
            state: partyDto.address.state,
            country: partyDto.address.country,
        },
        taxId: partyDto.taxId,
        phone: partyDto.phone,
        email: partyDto.email,
    };
}
function mapToDomainLineItem(lineItemDto) {
    return {
        productName: lineItemDto.productName,
        quantity: lineItemDto.quantity,
        tax: {
            vatPercent: lineItemDto.tax.vatPercent,
            taxBase: lineItemDto.tax.taxBase,
            vatAmount: lineItemDto.tax.vatAmount,
            grossAmount: lineItemDto.tax.grossAmount,
        },
    };
}
function mapToDomainVatDetails(vatDetailsDto) {
    return {
        vatPercent: vatDetailsDto.vatPercent,
        taxBase: vatDetailsDto.taxBase,
        vatAmount: vatDetailsDto.vatAmount,
    };
}
function mapToDomainBillingVerificationSystem(dto) {
    if (!dto)
        return null;
    return {
        qrImage: dto.qrImage,
        url: dto.url,
        type: dto.type,
    };
}
function mapToDomainInvoiceList(dto) {
    if (!dto) {
        throw new Error('Invalid ClubInvoiceListDTO');
    }
    return {
        invoiceId: dto.invoiceId,
        invoiceNumber: dto.invoiceNumber,
        invoiceType: dto.invoiceType,
        clubId: dto.clubId,
        clubName: dto.clubName,
        machineId: dto.machineId,
        machineName: dto.machineName,
        billingPeriod: dto.billingPeriod
            ? {
                startDate: dto.billingPeriod.startDate,
                endDate: dto.billingPeriod.endDate,
            }
            : null,
        issueDate: dto.issueDate,
        netPayout: dto.netPayout,
        currency: dto.currency,
    };
}
